import React, { useState } from 'react';

const ExpenseFormModal = ({ userId, categories, onClose, onSubmit }) => {
  const [title, setTitle] = useState('');
  const [amount, setAmount] = useState('');
  const [category, setCategory] = useState('');

  const handleSubmit = () => {
    if (!title || !amount || !category) return;
    const payload = {
      userId,
      title,
      amount: parseFloat(amount),
      category,
      date: new Date().toISOString().split('T')[0],
    };
    onSubmit(payload);
    onClose(); // close after submit
  };

  return (
    <div className="modal-backdrop-custom">
      <div className="modal-content-custom shadow-lg border rounded-4 p-4 bg-white">
        <h4 className="mb-3 fw-semibold text-center">Add New Expense</h4>

        <div className="mb-3">
          <label className="form-label">Title</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. Grocery, Cab Fare"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Amount (₹)</label>
          <input
            type="number"
            className="form-control"
            placeholder="Enter amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>

        <div className="mb-4">
          <label className="form-label">Category</label>
          <select
            className="form-select"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">Select Category</option>
            {categories.map((c, index) => (
              <option key={index} value={c.category_name}>
                {c.category_name}
              </option>
            ))}
          </select>
        </div>

        <div className="d-flex justify-content-end gap-2">
          <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-sm btn-primary" onClick={handleSubmit}>
            Add Expense
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpenseFormModal;
